import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, WingBlank, WhiteSpace, Badge } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import CommonUtils from '../utils/CommonUtils';
import '../styles/WithdrawHistory.css'

const history = require("history").createHashHistory()

class WithdrawHistory extends Component {
    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 80;
        this.setState({
            height
        })
        this.loadPageData(1, height)
    }

    loadPageData = (pageNum) => {
        let deviceId = decodeURIComponent(this.props.match.params.deviceId)
        DataFetcher.withdrawRecords({
            pageNum,
            pageSize: 20,
            deviceId,
        }, {
            success: (resp) => {
                let data = resp.data
                this.pageNum = data.pageNum;
                this.pageSize = data.pageSize;
                this.pages = data.pages;
                let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : []
                this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
                this.setState({
                    dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                    isLoading: false,
                    hasMore: this.pageNum < this.pages
                })
            }
        })
    }

    onEndReached = (event) => {
        if (this.state.isLoading || !this.state.hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.map((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
            return data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    renderRow = (rowData, sectionId, rowId) => {
        let statusText = '审核中', statusColor = '#04bbc5', remark = rowData.createTime
        if(rowData.status === 'AUDITING') {
            statusText = '审核中'
            statusColor = '#04bbc5'
        } else if(rowData.status === 'TRANSFERRED') {
            statusText = '已打款'
            statusColor = '#21b68a'
        } else if(rowData.status === 'REJECTED') {
            statusText = '已驳回'
            statusColor = '#aaa'
            if(CommonUtils.isNotEmpty(rowData.remark)) {
                remark = rowData.remark
            }
        }

        let statusBadge = (
            <Badge text={statusText} 
                   style={{backgroundColor: `${statusColor}`}}/>)

        return (
            <WingBlank size='sm' key={rowId}>
                <div className='row'>
                    <div className='icon'>
                        <i className='iconfont icon-icon' style={{color: '#04bbc5'}}/>
                    </div>
                    <div className='info'>
                        <div className='description'>
                            <span className='label'>提现金额&nbsp;&nbsp;</span>
                            <span className='value'>￥{rowData.amount}</span>
                        </div>
                        <div className='remark word-ellipsis'>{remark}</div>
                    </div>
                    <div className='status'>
                        {statusBadge}
                    </div>
                </div>
            </WingBlank>
        )
    }

    render() {
        const {dataSource, isLoading} = this.state;
        return (
            <div className='page-withdraw-history'>
                <NavBar mode="light" className='fixed' icon={<Icon type="left" color="black" size="md"/>} onLeftClick={history.goBack}>提现记录</NavBar>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 50
                    }}
                />
            </div>
        )
    }
}

export default WithdrawHistory;


// WEBPACK FOOTER //
// ./src/modules/WithdrawHistory.js